@use "variables" as *;
@use "../../helpers/tableStyles/TableStyles.scss";

.box {
  min-height: TableStyles.$table-item-min-height;
  width: calc(100vw - $spacing-2 - $spacing-2);

  @include TableStyles.table-item-layout;
}
